import AuthService from '@/services/AuthService';

export function isAuthenticated(store) {
  return AuthService.isAuthorized(store.state.auth.authUser) === true;
}

export function handleAuthNavigation(to, store) {
  const needsAuth = to.matched.some((record) => record.meta?.requiresAuth);
  const guestOnly = to.matched.some((record) => record.meta?.guestOnly);
  const authenticated = isAuthenticated(store);

  if (needsAuth && !authenticated) {
    return { path: '/login' };
  }

  if (guestOnly && authenticated) {
    return { path: '/authenticated/voting' };
  }

  return null;
}

export function createEnsureRegistrationTypeGuard(store, type) {
  return (to, from, next) => {
    const registration = store.state.registration;
    if (!registration || registration.type !== type) {
      store
        .dispatch('initRegistration', type)
        .then(() => next())
        .catch((error) => {
          console.error('Failed to initialize registration', { type, message: error?.message });
          next({ path: '/' });
        });
      return;
    }
    next();
  };
}

export function createEnsureRegistrationHasEmailGuard(store) {
  return (to, from, next) => {
    const registration = store.state.registration;
    if (registration?.person?.email) {
      next();
      return;
    }
    if (from?.path) {
      next(from);
      return;
    }
    next({ path: '/' });
  };
}
